import { AIResponse, Box, Button } from '@landtrustinc/design-system';
import React from 'react';

import type { UpgradePromptMessage } from '../../types';

type UpgradePromptProps = {
  msg: UpgradePromptMessage;
};

const UpgradePrompt: React.FC<UpgradePromptProps> = ({ msg }) => {
  return (
    <AIResponse key={msg.id} showDisclaimer={false} showHelpfulQuestion={false} showTitle={false}>
      <Box>
        <Box mb="var(--spacing-3)">{msg.content}</Box>
        <Button as="a" href={msg.ctaUrl} size="sm">
          {msg.ctaLabel}
        </Button>
      </Box>
    </AIResponse>
  );
};

export default UpgradePrompt;
